import _classCallCheck from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { Subject } from "rxjs";
import "hammerjs";
export var InputEventSource =
/*#__PURE__*/
function () {
  function InputEventSource(videoElement) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, InputEventSource);

    this.mouseMoveSource = new Subject();
    this.mouseMove$ = this.mouseMoveSource.asObservable();
    this.mouseButtonSource = new Subject();
    this.mouseButton$ = this.mouseButtonSource.asObservable();
    this.zoomSource = new Subject();
    this.zoom$ = this.zoomSource.asObservable();
    this.keySource = new Subject();
    this.key$ = this.keySource.asObservable();
    this.focusSource = new Subject();
    this.focus$ = this.focusSource.asObservable();
    this.mouseLocked = false;
    this.options = options;
    this.videoElement = videoElement;
    this.onPointerlockChange = this.onPointerlockChange.bind(this);
    this.onMouseWheel = this.onMouseWheel.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onPress = this.onPress.bind(this);
    this.onPan = this.onPan.bind(this);
    this.onPinch = this.onPinch.bind(this);
    this.hammer = new Hammer(this.videoElement);
    this.hammer.get('pan').set({
      direction: Hammer.DIRECTION_ALL
    });
    this.hammer.get('pinch').set({
      enable: true
    });
    this.startInput();
  }

  _createClass(InputEventSource, [{
    key: "startInput",
    value: function startInput() {
      if (this.options.lockMouse) {
        document.addEventListener('pointerlockchange', this.onPointerlockChange);
      }

      this.videoElement.addEventListener('wheel', this.onMouseWheel);
      this.videoElement.addEventListener('mousedown', this.onMouseDown);
      this.videoElement.addEventListener('mouseup', this.onMouseUp);
      this.videoElement.addEventListener('mousemove', this.onMouseMove);
      this.videoElement.addEventListener('keydown', this.onKeyDown);
      this.videoElement.addEventListener('keyup', this.onKeyUp);
      document.addEventListener('blur', this.onBlur);
      this.videoElement.addEventListener('blur', this.onBlur);
      this.hammer.on('press pressup', this.onPress);
      this.hammer.on('panstart panmove panend pancancel', this.onPan);
      this.hammer.on('pinchin pinchout', this.onPinch);
    }
  }, {
    key: "stopInput",
    value: function stopInput() {
      if (this.options.lockMouse) {
        document.removeEventListener('pointerlockchange', this.onPointerlockChange);
      }

      this.videoElement.removeEventListener('wheel', this.onMouseWheel);
      this.videoElement.removeEventListener('mousedown', this.onMouseDown);
      this.videoElement.removeEventListener('mouseup', this.onMouseUp);
      this.videoElement.removeEventListener('mousemove', this.onMouseMove);
      this.videoElement.removeEventListener('keydown', this.onKeyDown);
      this.videoElement.removeEventListener('keyup', this.onKeyUp);
      document.removeEventListener('blur', this.onBlur);
      this.videoElement.removeEventListener('blur', this.onBlur);
      this.hammer.off('press pressup', this.onPress);
      this.hammer.off('panstart panmove panend pancancel', this.onPan);
      this.hammer.off('pinchin pinchout', this.onPinch);
    }
  }, {
    key: "canSend",
    value: function canSend() {
      return this.videoElement.videoWidth;
    }
  }, {
    key: "onBlur",
    value: function onBlur(_) {
      if (!this.canSend()) return;
      this.focusSource.next(false);
    }
  }, {
    key: "onPointerlockChange",
    value: function onPointerlockChange() {
      if (!this.canSend()) return;
      this.mouseLocked = document.pointerLockElement === this.videoElement;

      if (this.mouseLocked) {
        this.mouseMoveSource.next({
          deltaX: 0,
          deltaY: 0,
          x: this.lockPosition.x,
          y: this.lockPosition.y,
          delta: false
        });
      } else {
        this.focusSource.next(false);
      }
    }
  }, {
    key: "onMouseWheel",
    value: function onMouseWheel(event) {
      if (!this.canSend()) return false;
      event.preventDefault();
      var wheelDelta = Math.max(-1, Math.min(1, event.deltaY || -event.detail));
      this.zoomSource.next({
        delta: -wheelDelta
      });
      return false;
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      if (!this.canSend()) return false;

      if (this.options.lockMouse && !this.mouseLocked) {
        return false;
      }

      this.mouseButtonSource.next({
        buttonDown: true,
        button: event.button,
        x: event.offsetX,
        y: event.offsetY
      });
      return false;
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp(event) {
      if (!this.canSend()) return false;

      if (this.options.lockMouse && !this.mouseLocked) {
        this.videoElement.requestPointerLock();
        this.lockPosition = {
          x: event.offsetX,
          y: event.offsetY
        };
        return false;
      }

      this.mouseButtonSource.next({
        buttonDown: false,
        button: event.button,
        x: event.offsetX,
        y: event.offsetY
      });
      return false;
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      if (!this.canSend()) return false;
      if (this.options.lockMouse && !this.mouseLocked) return false;
      this.mouseMoveSource.next({
        deltaX: event.movementX,
        deltaY: event.movementY,
        x: event.offsetX,
        y: event.offsetY,
        delta: this.mouseLocked
      });
      return false;
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      if (!this.canSend()) return false;

      if (!event.repeat) {
        this.keySource.next({
          keyDown: true,
          key: event.key
        });
      }

      return false;
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(event) {
      if (!this.canSend()) return false;
      this.keySource.next({
        keyDown: false,
        key: event.key
      });
      return false;
    }
  }, {
    key: "onPress",
    value: function onPress(event) {
      if (!this.canSend()) return false;

      if (event.pointerType === 'touch') {
        if (event.eventType === 1) {
          this.isPress = true;
          this.mouseButtonSource.next({
            button: 0,
            buttonDown: true,
            x: event.pointers[0].layerX,
            y: event.pointers[0].layerY
          });
        } else {
          if (this.isPress) {
            this.isPress = false;
            this.mouseButtonSource.next({
              button: 0,
              buttonDown: false,
              x: event.pointers[0].layerX,
              y: event.pointers[0].layerY
            });
          }
        }
      }
    }
  }, {
    key: "onPan",
    value: function onPan(event) {
      if (!this.canSend()) return false;

      if (event.pointerType === 'touch') {
        var _this$videoElement$ge = this.videoElement.getBoundingClientRect(),
            width = _this$videoElement$ge.width,
            height = _this$videoElement$ge.height,
            left = _this$videoElement$ge.left,
            top = _this$videoElement$ge.top;

        var x = Math.max(0, Math.min(width, event.center.x - left));
        var y = Math.max(0, Math.min(height, event.center.y - top));

        if (event.type === 'panstart') {
          this.mouseButtonSource.next({
            button: 0,
            buttonDown: true,
            x: x,
            y: y
          });
        } else if (event.type === 'panend') {
          this.mouseButtonSource.next({
            button: 0,
            buttonDown: false,
            x: x,
            y: y
          });
        } else if (event.type === 'panmove') {
          if (this.lastPan && this.lastPan.x == x && this.lastPan.y == y) return;
          this.lastPan = {
            x: x,
            y: y
          };
          this.mouseMoveSource.next({
            deltaX: 0,
            deltaY: 0,
            x: x,
            y: y,
            delta: false
          });
        }
      }
    }
  }, {
    key: "onPinch",
    value: function onPinch(event) {
      if (!this.canSend()) return false;

      if (event.type === 'pinchin') {
        this.zoomSource.next({
          delta: -1
        });
      } else if (event.type === 'pinchout') {
        this.zoomSource.next({
          delta: 1
        });
      }
    }
  }]);

  return InputEventSource;
}();